
export default function TagUrlComponent() {
    'ngInject';
    return {
        restrict: 'E',
        template: require('./tag-url.html'),
        scope: {},
        bindToController: {
            protocol: '@',
            url: '@',
            text: '@'
        },
        controllerAs: 'vm',
        controller: function () {
            this.hyperlink = this.protocol + "://" + this.url;
        }
    };
}
